import "src/styles/lineOfDots.css";

export default function LineOfDots() {
  return <div className="line-of-dots line-of-dots-container"></div>;
}
